import { observer } from 'mobx-react-lite';
import { useNavigate, useLocation } from 'react-router-dom';
import Modalcontainer from '../modalcontainer';
import styles from './styles.module.scss';
import { cardsblockStore } from '../cardsblock/cardsblock.store';
import { unityProviderStore } from '../UnityLoader/unity.provider.store';

const ShowAvatarSwitcher: React.FC = observer(() => {
  const { selectedRoomId, setShowSwitcher, setSelectedOption } =
    cardsblockStore;
  const { openZoomChat } = unityProviderStore;
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelectOption = (option: string, roomState = true) => {
    setShowSwitcher(false);
    openZoomChat(true);
    if (roomState) {
      setSelectedOption(option);
      navigate(`/room/${selectedRoomId}`, {
        state: {
          runImmediately: true,
        },
      });
    }
  };

  return (
    <Modalcontainer
      closePopup={() => {
        handleSelectOption(
          'withAvatar',
          location.pathname.split('/')[1] === 'room',
        );
      }}
      canClose={false}
    >
      <div className={styles.AvatarSwitcher}>
        <p className={styles.chooseMode}>Choose the Mode!</p>
        <p className={styles.joinMeeting}>
          Join the meeting without an avatar in case of a low internet
          connection.
        </p>
        <div className={styles.radio_inputs}>
          <label className={styles.radio}>
            <input
              type="radio"
              value="withAvatar"
              onClick={() => handleSelectOption('withAvatar')}
            />
            <span className={styles.name}>With Avatar</span>
          </label>
          <label className={styles.radio}>
            <input
              type="radio"
              value="withoutAvatar"
              onClick={() => handleSelectOption('withoutAvatar')}
            />
            <span className={styles.name}>Without Avatar</span>
          </label>
        </div>
      </div>
    </Modalcontainer>
  );
});

export default ShowAvatarSwitcher;
